<template>
  <div class="section std gallery">
    <div class="section-container">
      <div class="content">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-md-12 materials-title">
              <img class="materials-icon mr-2" src="/media/icons/svg/cubes.svg" alt=""/>
              <h2>{{ trans.get('public.home.materials.materials') }}</h2>
            </div>
            <div class="col-md-12 up d-flex align-items-center">
              <img src="/media/vetrina/materials.jpg" alt="materiali"/>
              <p>
                {{ trans.get('public.home.materials.desc') }}

              </p>
            </div>
            <div class="col-md-12 down row">
              <div class="col-md-4">
                <div class="titolo">
                  <img
                      class="mr-2"
                      src="/media/icons/svg/properties.svg"
                      alt=""
                  />
                  <h4>{{ trans.get('public.home.materials.properties') }}</h4>
                </div>
                <ul>
                  <li>{{ trans.get('public.home.materials.list1.item1') }}</li>
                  <li>{{ trans.get('public.home.materials.list1.item2') }}</li>
                  <li>{{ trans.get('public.home.materials.list1.item3') }}</li>
                  <li>{{ trans.get('public.home.materials.list1.item4') }}</li>
                  <li>{{ trans.get('public.home.materials.list1.item5') }}</li>
                  <li>{{ trans.get('public.home.materials.list1.item6') }}</li>
                  <li>{{ trans.get('public.home.materials.list1.item7') }}</li>
                  <li>{{ trans.get('public.home.materials.list1.item8') }}</li>
                  <li>{{ trans.get('public.home.materials.list1.item9') }}</li>
                </ul>
              </div>
              <div class="col-md-4">
                <div class="titolo">
                  <img class="mr-2" src="/media/icons/svg/types.svg" alt=""/>
                  <h4>{{ trans.get('public.home.materials.types') }}</h4>
                </div>
                <ul>
                  <li>{{ trans.get('public.home.materials.list2.item1') }}</li>
                  <li>{{ trans.get('public.home.materials.list2.item2') }}</li>
                  <li>{{ trans.get('public.home.materials.list2.item3') }}</li>
                  <li>{{ trans.get('public.home.materials.list2.item4') }}</li>
                  <li>{{ trans.get('public.home.materials.list2.item5') }}</li>
                  <li>{{ trans.get('public.home.materials.list2.item6') }}</li>
                  <li>{{ trans.get('public.home.materials.list2.item7') }}</li>
                </ul>
              </div>
              <div class="col-md-3">
                <div class="titolo">
                  <img
                      class="mr-2"
                      src="/media/icons/svg/finishes.svg"
                      alt=""
                  />
                  <h4>{{ trans.get('public.home.materials.finishes') }}</h4>
                </div>
                <ul>
                  <li>{{ trans.get('public.home.materials.list3.item1') }}</li>
                  <li>{{ trans.get('public.home.materials.list3.item2') }}</li>
                  <li>{{ trans.get('public.home.materials.list3.item3') }}</li>
                  <li>{{ trans.get('public.home.materials.list3.item4') }}</li>
                  <li>{{ trans.get('public.home.materials.list3.item5') }}</li>
                  <li>{{ trans.get('public.home.materials.list3.item6') }}</li>
                </ul>
              </div>
            </div>
          </div>
          <hr class="desktop">
        </div>
      </div>
    </div>
    <hr class="wide">
  </div>
</template>

<script>
export default {
  name: "materials.vue",
  components: {},
  data() {
    return {};
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.section {
  background-color: #3b3b43;
  color: #fff;
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;
  font-size: 1em;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }
  .container {
    font-size: 1em;
    @media (min-width: 1921px){
      font-size: var(--font-size-large);
    }
    height: calc(100vh - 80px);
    width: 100%;
    max-width: 100% !important;
    padding: 0;


    .row {
      width: 90%;
      max-width: 90%;
    }
  }

  //height: 860px!important;
  hr {
    background-color: #707070;
    border-color: #707070;
    margin-top: 50px;

    &.wide {
      display: none;
    }
  }

  .materials-title {
    display: flex;
    align-items: baseline;
  }

  .down {
    justify-content: space-between;

    .titolo {
      display: flex;
      align-items: center;

      h4 {
        color: #fff;
        margin: 0;
      }
    }

    ul {
      margin-left: 0;
      list-style: none;
      //list-style: square inside url('data:image/gif;base64,R0lGODlhBQAKAIABAAAAAP///yH5BAEAAAEALAAAAAAFAAoAAAIIjI+ZwKwPUQEAOw==');
      li {

        &:before {
          content: "-";
          position: absolute;
          margin-left: -10px;
        }
      }

    }
  }

  .up {
    background-color: #46464e;
    padding-left: unset;
    padding-right: unset;
    margin-bottom: 50px;

    img {
      width: 50%;
    }

    p {
      color: #D8D8D8;
      padding: 0 25px;
    }

    @media (max-width: 576px) {
      padding: 0 10px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        margin: 20px 0;
      }
      p {
        padding-bottom: 20px;
      }
    }
  }

  h2 {
    color: #fff;

  }
}

@media (max-width: 576px) {
  .container, .content, .section-container, .section.std {
    height: 100% !important;
  }
  .section {
    padding: 25px 0;

    .section-container {
      margin: 0;
      max-width: 100%;

      .content {
        .container {
          padding: 0;

          h2 {
            font-size: 18px;
            margin-bottom: 22px;
          }

          .up {
            margin: 0;
            padding: 0;

            img {
              margin: 0;
            }

            p {
              margin: 22px;
              padding: 0;
            }
          }

          .down {
            margin: 33px 20px 0 20px;
            padding: 0;

            .titolo {
              h4 {
                font-size: 18px;
              }
            }

            ul {
              list-style-position: outside;
              margin-top: 18px;
              margin-bottom: 40px;

              li {
                margin: 12px 0;
              }
            }

            > div[class^=col-] {
              padding: 0;
              padding-left: 17px;
            }
          }

          hr {
            margin: 0;
          }
        }
      }
    }
  }
}

@media (min-width: 1921px) {
  .section {
    justify-content: center;
    padding-bottom: 0;

    .section-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
    }

    hr {
      &.wide {
        width: calc(100% - var(--public-menu-width));
        align-self: flex-end;
        display: block;
        margin-bottom: 0;
      }

      &.desktop {
        display: none;
      }
    }
  }
  .section .container {
    height: 100%;
  }
}

@media (min-width: 2000px) and (min-height: 800px) {
  .section.std.gallery {
    padding-top: 200px;
    padding-bottom: 200px;
  }
  .section {

    hr {
      &.wide {
        position: absolute;
        bottom: 0;
      }
    }

  }

}
</style>
